document.addEventListener("DOMContentLoaded", () => {
  // get the checked size variant (will have to decide with the client for the variant title so that we get it correctly)
  const selectedSwatch = document.querySelector(".variant-picker__option-values.size input:checked");
  if (selectedSwatch) {
    const swatchId = selectedSwatch.id;
    const swatchLabel = document.querySelector(`label[for="${swatchId}"]`);

    if (swatchLabel) {
      setMinQuantity(swatchLabel);
    }
  }
});

// function to set the min and max values for the quantity selector
function setMinQuantity(e) {
  // the option's value (the title)
  const optionValue = e.innerText.trim();
  const quantitySelectorElement = document.querySelector('[data-block-type="quantity-selector"] .quantity-selector');
  if (!quantitySelectorElement) return;

  // input and buttons 
  const qtyInput = quantitySelectorElement.querySelector("input");
  const increaseButton = quantitySelectorElement.querySelector(".quantity-selector__button.increase");
  const decreaseButton = quantitySelectorElement.querySelector(".quantity-selector__button.decrease");

  if (!qtyInput || !increaseButton || !decreaseButton) {
    console.error("Quantity input or buttons not found");
    return;
  }

  let min = 1;
  let max = null;

  // update the min and max based on - or +
  if (optionValue.includes("-")) {
    [min, max] = optionValue.split("-").map(Number);
  } else if (optionValue.includes("+")) {
    [min] = optionValue.split("+").map(Number);
  }

  // set min/max
  qtyInput.min = min;
  qtyInput.max = max;
  console.log('max', max)

  // update the input value
  qtyInput.value = min;
  qtyInput.setAttribute("value", min);

  // in theme.js updated the private method: updateUI_fn
  // updateUI_fn = function() {
  //   const min = parseInt(__privateGet(this, _inputElement).min, 10) || 1;
  //   const max = __privateGet(this, _inputElement).max ? parseInt(__privateGet(this, _inputElement).max, 10) : null;
  //   const currentValue = __privateGet(this, _inputElement).quantity;
  //   __privateGet(this, _decreaseButton).disabled = currentValue <= min;
  //   __privateGet(this, _increaseButton).disabled = max !== null && currentValue >= max;
  // };

  //  Manually call the component's UI update method
  quantitySelectorElement.dispatchEvent(new Event("input", { bubbles: true }));
  quantitySelectorElement.dispatchEvent(new Event("change", { bubbles: true }));

  updateButtonState(qtyInput, increaseButton, decreaseButton);
}

function updateButtonState(qtyInput, increaseButton, decreaseButton) {
  const currentValue = parseInt(qtyInput.value, 10);
  const min = parseInt(qtyInput.min, 10);
  const max = qtyInput.max ? parseInt(qtyInput.max, 10) : null;

  decreaseButton.disabled = currentValue <= min;
  increaseButton.disabled = max !== null && currentValue >= max;
}


addEventListener("DOMContentLoaded", (event) => {
  const input = document.querySelector('.quantity-selector__input');

  input.addEventListener('input', () => {
    const max = parseInt(input.max);
    const value = parseInt(input.value);

    if (value > max) {
      input.value = max;
    }
  });

})